import React, { useEffect, useState } from "react";
import heroBanner from "../assets/images/hero-banner.png";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import careers from "../assets/images/career.png";
import upload from "../assets/images/Upload.svg";
import connectionbanner from "../assets/images/connection-banner.png";
import { Link } from "react-router-dom";
import "../styles/bubbles.css";
import "../styles/style.css";
import careervalidationSchema from "../assets/validation/careerform";
import { Formik, Field, Form, ErrorMessage } from "formik";
import axios from "axios";

function Careers() {


  return (
  
        <>
          {/* <!-- preloader end  --> */}

          {/* <!-- Mouse Cursor Start -->   */}
          <div className="mouse-cursor cursor-outer"></div>
          <div className="mouse-cursor cursor-inner"></div>

          <header
            className="top-header inner-banner"
            style={{ background: `url(${heroBanner}) no-repeat top center` }}
          >
            <div id="stars"></div>
            <div id="stars2"></div>
            <div id="stars3"></div>
            <Navbar />
            <section className="banner-caption flex-center">
              <div className="caption-header text-white">
                <div className="container text-center">
                  <h1 className="caption-title">
                    {" "}
                    Join Us: Shape the Future with <br /> Entegation
                    Technologies{" "}
                  </h1>
                </div>
              </div>
            </section>
          </header>
          <section className="home-about light-gradient-bg py-5">
            <div className="container">
              <div className="row py-5 align-items-center">
                <div className="col-lg-8">
                  <div className="column-left">
                    <div className="title mb-5">
                      <h1 className="section-title">Careers</h1>
                    </div>
                    <div className="column-left-content home-about-content">
                      <p className="mb-0">
                        {" "}
                        At Entegation Technologies, we’re not just building
                        software solutions; we’re shaping the future of
                        enterprise technology. Our team is made up of talented
                        professionals who are passionate about innovation,
                        collaboration, and making a difference in the digital
                        world. If you’re ready to push the boundaries of what’s
                        possible, we invite you to join us on this exciting
                        journey.{" "}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="column-right">
                    <div className="home-about-right d-flex justify-content-end">
                      <div className="thumbnail-block">
                        <div className="card-image">
                          <img
                            src={careers}
                            alt="About-image"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="center-caption py-5">
            <div className="container">
              <div className="row py-5">
                <div className="col-12">
                  <div className="text-white">
                    <div className="title pb-5">
                      <h1 className="section-title text-white">
                        {" "}
                        Who We’re Looking For{" "}
                      </h1>
                    </div>
                    <p className="text-white">
                      {" "}
                      We’re on the lookout for forward-thinkers, problem
                      solvers, and innovators. Whether you’re an experienced
                      technology professional or just starting your career, if
                      you’re excited by the possibilities of digital
                      transformation and passionate about delivering impactful
                      solutions, we want to hear from you.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="career-form py-5">
            <div className="container">
              <div className="row py-5 d-flex align-items-center">
                <div className="col-lg-6">
                  <div className="career-text">
                    <div className="column-left">
                      <div className="title mb-5">
                        <h1 className="section-title">Join Our Team</h1>
                      </div>
                      <div className="column-left-content home-about-content">
                        <p className="mb-0">
                          {" "}
                          Ready to shape the future with Entegation
                          Technologies? Fill out the form below to apply or
                          express your interest.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="career-contact">
                    <Formik
                      initialValues={{
                        fullname: "",
                        email: "",
                        phonenumber: "",
                        position: "",
                        linkedinprofile: "",
                        comments: "",
                        cv: null,
                        checkbox: false,
                      }}
                      validationSchema={careervalidationSchema}
                      onSubmit={(values, { setSubmitting, resetForm }) => {
                        const formData = new FormData();
                        formData.append("fullname", values.fullname);
                        formData.append("email", values.email);
                        formData.append("phonenumber", values.phonenumber);
                        formData.append("position", values.position);
                        formData.append(
                          "linkedinprofile",
                          values.linkedinprofile
                        );
                        formData.append("comments", values.comments);
                        formData.append("cv", values.cv);
                        formData.append("checkbox", values.checkbox);
                        axios
                          .post(
                            "http://localhost:5000/api/send-careers",
                            formData,
                            {
                              headers: {
                                "Content-Type": "multipart/form-data",
                              },
                            }
                          )
                          .then((response) => {
                            alert(
                              "Career Form submitted and email sent successfully!"
                            );
                            console.log(values, ">>>>>>>>>>");
                          })
                          .catch((error) => {
                            console.log(values, ">>>>>>>>>>");
                            alert("Error sending email!");
                            console.error(error);
                          })
                          .finally(() => {
                            setSubmitting(false);
                            resetForm();
                          });
                      }}
                    >
                      {({ isSubmitting, setFieldValue }) => (
                        <Form>
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="mb-3">
                                <div className="form-group">
                                  <div className="palceholder">
                                    <label htmlFor="name">Full Name</label>
                                    <span className="star">*</span>
                                  </div>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="fullname"
                                    required
                                  />
                                  <ErrorMessage
                                    name="fullname"
                                    component="div"
                                    style={{ color: "red", marginTop: "5px" }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="mb-3">
                                <div className="form-group">
                                  <div className="palceholder">
                                    <label htmlFor="name">Email Address</label>
                                    <span className="star">*</span>
                                  </div>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="email"
                                    required
                                  />
                                  <ErrorMessage
                                    name="email"
                                    component="div"
                                    style={{ color: "red", marginTop: "5px" }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="mb-3">
                                <div className="form-group">
                                  <div className="palceholder">
                                    <label htmlFor="name">Phone Number</label>
                                    <span className="star">*</span>
                                  </div>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="phonenumber"
                                    required
                                  />
                                  <ErrorMessage
                                    name="phonenumber"
                                    component="div"
                                    style={{ color: "red", marginTop: "5px" }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="mb-3">
                                <div className="form-group">
                                  <div className="palceholder">
                                    <label htmlFor="name">Phone Number</label>
                                    <span className="star">*</span>
                                  </div>
                                  <Field
                                    as="select"
                                    name="position"
                                    className="form-select"
                                    aria-label="Default select example"
                                  >
                                    <option selected disabled>
                                      {" "}
                                      Position{" "}
                                    </option>
                                    <option value="1"> One </option>
                                    <option value="2"> Two </option>
                                    <option value="3"> Three </option>
                                  </Field>
                                  <ErrorMessage
                                    name="position"
                                    component="div"
                                    style={{ color: "red", marginTop: "5px" }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="mb-3">
                                <div className="form-group">
                                  <div className="palceholder">
                                    <label htmlFor="name">
                                      LinkedIn Profile
                                    </label>
                                    <span className="star">*</span>
                                  </div>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="linkedinprofile"
                                    required
                                  />
                                  <ErrorMessage
                                    name="linkedinprofile"
                                    component="div"
                                    style={{ color: "red", marginTop: "5px" }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="mb-3">
                                <div className="form-group">
                                  <div className="palceholder">
                                    <label htmlFor="name">Comments</label>
                                    <span className="star">*</span>
                                  </div>
                                  <Field
                                    as="textarea"
                                    className="form-control"
                                    rows="5"
                                    name="comments"
                                  />
                                  <ErrorMessage
                                    name="comments"
                                    component="div"
                                    style={{ color: "red", marginTop: "5px" }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="mb-3">
                                <label
                                  htmlFor="formFile"
                                  className="form-label"
                                >
                                  Resume/CV <span>*</span>
                                </label>
                                <div className="input-group custom-file-button">
                                  <label
                                    className="input-group-text"
                                    htmlFor="inputGroupFile"
                                  >
                                    <span className="pe-2">
                                      <img src={upload} alt="icon" />
                                    </span>
                                    Upload{" "}
                                  </label>
                                  <input
                                    name="cv"
                                    type="file"
                                    accept="application/pdf"
                                    className="form-control"
                                    id="inputGroupFile"
                                    onChange={(event) => {
                                      const file = event.currentTarget.files[0]; // Get the selected file
                                      setFieldValue("cv", file); // Set the file in Formik state
                                    }}
                                  />

                                  <ErrorMessage
                                    name="cv"
                                    component="div"
                                    style={{ color: "red", marginTop: "5px" }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="mb-3 form-check">
                                <Field
                                  type="checkbox"
                                  name="checkbox"
                                  className="form-check-input"
                                  id="exampleCheck1"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="exampleCheck1"
                                >
                                  I agree to the privacy policy and terms of
                                  service.
                                </label>
                                <ErrorMessage
                                  name="checkbox"
                                  component="div"
                                  style={{ color: "red", marginTop: "5px" }}
                                />
                              </div>
                              <button
                                type="submit"
                                disabled={isSubmitting}
                                className="btn btn-theme mt-4 pe-4 ps-4"
                              >
                                {" "}
                                Submit{" "}
                              </button>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="approach light-bg-column py-5 mb-5 service-count">
            <div className="container">
              <div className="row py-5 gx-5">
                <div className="col-12 text-center">
                  <div className="title mb-5">
                    <h1 className="section-title mb-5"> Why Work With Us? </h1>
                    <p className="section-title-sub mb-5 col-7 mx-auto">
                      {" "}
                      At Entegation Technologies, we believe that our people are
                      our greatest asset. That’s why we’ve created an
                      environment where innovation thrives, creativity is
                      encouraged, and careers can flourish.{" "}
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 border-right-full border-bottom-line-left pb-5">
                  <div className="list-approach text-center">
                    <div className="list-icon mb-5">
                      <span>01</span>
                    </div>
                    <div className="column-title mb-4">
                      <h1>Innovative Work Environment</h1>
                    </div>
                    <div className="column-content ps-lg-5 pe-lg-5 pb-3">
                      <p className="ps-lg-5 pe-lg-5">
                        {" "}
                        Here, every day brings new challenges and opportunities.
                        We are passionate about solving complex problems and
                        delivering transformative solutions to our clients.
                        You’ll work alongside some of the brightest minds in the
                        industry, who are always pushing the envelope of what
                        technology can do.{" "}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 border-bottom-line-right">
                  <div className="list-approach text-center">
                    <div className="list-icon mb-5">
                      <span>02</span>
                    </div>
                    <div className="column-title mb-4">
                      <h1>Continuous Learning</h1>
                    </div>
                    <div className="column-content ps-lg-5 pe-lg-5">
                      <p className="ps-lg-5 pe-lg-5">
                        {" "}
                        We believe that learning never stops. Whether it’s
                        attending workshops, gaining certifications, or
                        participating in cutting-edge projects, you’ll have
                        countless opportunities to develop new skills and
                        advance your career.{" "}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 border-right-full">
                  <div className="list-approach text-center pt-5">
                    <div className="list-icon mb-5">
                      <span>03</span>
                    </div>
                    <div className="column-title mb-4">
                      <h1>Inclusive Culture</h1>
                    </div>
                    <div className="column-content ps-lg-5 pe-lg-5">
                      <p className="ps-lg-5 pe-lg-5">
                        {" "}
                        At Entegation, diversity isn’t just a buzzword—it’s our
                        strength. We foster a collaborative and inclusive
                        workplace where every team member’s voice is heard, and
                        different perspectives are celebrated.{" "}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="list-approach text-center pt-5">
                    <div className="list-icon mb-5">
                      <span>04</span>
                    </div>
                    <div className="column-title mb-4">
                      <h1>Work-Life Balance</h1>
                    </div>
                    <div className="column-content ps-lg-5 pe-lg-5">
                      <p className="ps-lg-5 pe-lg-5">
                        {" "}
                        We understand the importance of balancing professional
                        success with personal well-being. Our flexible working
                        environment and comprehensive benefits package ensure
                        that our employees can thrive both at work and in life.{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="bottom-bg py-5">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="dark-bg-block">
                    <div className="tech-integration d-flex align-items-center">
                      <div className="col-lg-4">
                        <div className="contact-info-block text-white">
                          <p className="py-4">
                            {" "}
                            Be Part of Something Bigger. Be Part of Entegation
                            Technologies.{" "}
                          </p>
                          <Link
                            to="contact-us"
                            className="btn btn-outline-white"
                          >
                            Let’s Talk
                          </Link>
                        </div>
                      </div>
                      <div className="col">
                        <div className="connection-banner d-flex justify-content-end">
                          <img
                            src={connectionbanner}
                            alt="Integration banner"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* <!-- footer --> */}
          <Footer />
          <div className="progress-wrap">
            <svg
              className="progress-circle svg-content"
              width="100%"
              height="100%"
              viewBox="-1 -1 102 102"
            >
              <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
            </svg>
          </div>
          <Helmet>
            <title>Entegation Technologies | Careers</title>
            <script src="/assets/js/script.js"></script>
            <script src="/assets/js/form.js"></script>
          </Helmet>
        </>
    
  );
}

export default Careers;
